import { buildConnectToAiEvent, type ConnectToAiBiEvent, type ConnectToAiBiOption } from '@fiverr-private/layout_menus';
import isTouchDevice from '../../../lib/isTouchDevice';
import { sendBigQueryEvent } from '../../../utils/bigQuery';

interface ReportConnectToAiParams {
    type: ConnectToAiBiEvent;
    action: 'impression' | 'click';
    option?: ConnectToAiBiOption;
}

export const reportConnectToAi = ({ type, action, option }: ReportConnectToAiParams) => {
    sendBigQueryEvent(buildConnectToAiEvent({ type, action, option, isTouch: isTouchDevice() }));
};
